document.addEventListener('findstrLoaded', () => {
  const findstr = window.findstr || {};

  findstr.hooks.addAction(
    'searchResults',
    'main_search',
    function (results, group, field) {
      if (field) {
        const htmlQueryTerm = document.querySelector(
          '.findstr-search-term[data-group="' + group + '"]'
        );
        const htmlQueryCount = document.querySelector(
          '.findstr-results-count[data-group="' + group + '"]'
        );

        if (htmlQueryTerm) {
          htmlQueryTerm.textContent = results.query;
        }

        if (htmlQueryCount) {
          htmlQueryCount.textContent = results.totalHits;
        }

        if ('pagination' !== field.type) {
          const container = document.querySelector(
            '.search-window__results-wrapper, .findstrResultsContainer'
          );
          if (container) {
            container.scrollTop = 0;
          }
        }
      }
    }
  );

  findstr.hooks.addFilter(
    'urlManagementDisabled',
    'otstcfq',
    (disabled, group) => {
      if ('search-autocomplete' === group || 'home_search' === group) {
        return true;
      }
      return disabled;
    }
  );

  findstr.hooks.addFilter(
    'searchResults',
    'searchAutocomplete',
    function (results, group) {
      if ('main-search' === group) {
        results.hits.map((hit) => {
          if ('search-block' === hit.post_type) {
            hit.hasBlock = true;
          }
          return hit;
        });
      }
      return results;
    }
  );
});
